module.exports = __webpack_public_path__ + "img/companies.242b0974.svg";